const getters = {
  menuList: (state) => state.permission.menuList,
  menuPerssions: (state) => state.permission.menuPerssions,
  btnPermissions: (state) => state.permission.btnPermissions,
  allMenuPath: (state) => state.permission.allMenuPath,
  menuFlag: (state) => state.permission.menuFlag,
  userFlag: (state) => state.user.userFlag,
  userName: (state) => state.user.userName,
  userInfo: (state) => state.user.userInfo,
  userOrg: (state) => state.user.userOrg,
  orgCategoryUuid: (state) => state.user.orgCategoryUuid,
  userRoles: (state) => state.user.userRoles,
  appBasicData: (state) => state.app.appBasicData,
  viewTagList: (state) => state.tagViews.viewTagList,
};
export default getters;
